<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="distributor.company_id && distributor.company_id > 0" @invoke-method="dbGetDistributor(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="distributor.company_id && distributor.company_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('distributors.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in distributor_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != distributor.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('distributors.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_distributor.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'distributors' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="distributor.status" class="ribbon ribbon-top-right" :class="`ribbon-${distributor.status_class}`">
                            <span class="ribbon-span">{{ distributor.status }}</span>
                        </div>
                        <v-form ref="formDistributor">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="distributor_dialog"
                                    v-model="distributor.company_id"
                                    :label="$t('lang.company_id')"
                                    :counter="showCounter(distributor.company_id, 'distributors.company_id')"
                                    :rules="ifValid('distributors.company_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.parent_id"
                                    :label="$t('lang.parent_id')"
                                    :counter="showCounter(distributor.parent_id, 'distributors.parent_id')"
                                    :rules="ifValid('distributors.parent_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.stripe_id"
                                    :label="$t('lang.stripe_id')"
                                    :counter="showCounter(distributor.stripe_id, 'distributors.stripe_id')"
                                    :rules="ifValid('distributors.stripe_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.zoho_customer_id"
                                    :label="$t('lang.zoho_customer_id')"
                                    :counter="showCounter(distributor.zoho_customer_id, 'distributors.zoho_customer_id')"
                                    :rules="ifValid('distributors.zoho_customer_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.organisation_type_id"
                                    :label="$t('lang.organisation_type_id')"
                                    :counter="showCounter(distributor.organisation_type_id, 'distributors.organisation_type_id')"
                                    :rules="ifValid('distributors.organisation_type_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.company"
                                    :label="`${$t('lang.company')} *`"
                                    :counter="showCounter(distributor.company, 'distributors.company')"
                                    :rules="ifValid('distributors.company')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.company_short"
                                    :label="$t('lang.company_short')"
                                    :counter="showCounter(distributor.company_short, 'distributors.company_short')"
                                    :rules="ifValid('distributors.company_short')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.website"
                                    :label="$t('lang.website')"
                                    :counter="showCounter(distributor.website, 'distributors.website')"
                                    :rules="ifValid('distributors.website')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.correspondence_method"
                                    :label="`${$t('lang.correspondence_method')} *`"
                                    :counter="showCounter(distributor.correspondence_method, 'distributors.correspondence_method')"
                                    :rules="ifValid('distributors.correspondence_method')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.currency_code"
                                    :label="`${$t('lang.currency_code')} *`"
                                    :counter="showCounter(distributor.currency_code, 'distributors.currency_code')"
                                    :rules="ifValid('distributors.currency_code')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.exchange_rate_id"
                                    :label="`${$t('lang.exchange_rate_id')} *`"
                                    :counter="showCounter(distributor.exchange_rate_id, 'distributors.exchange_rate_id')"
                                    :rules="ifValid('distributors.exchange_rate_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="distributor.payment_term_id"
                                    :label="$t('lang.payment_term')"
                                    :items="payment_terms"
                                    item-value="payment_term_id"
                                    item-text="payment_term_id"
                                    :rules="ifValid('distributors.payment_term_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.turn_around_days"
                                    :label="$t('lang.turn_around_days')"
                                    :counter="showCounter(distributor.turn_around_days, 'distributors.turn_around_days')"
                                    :rules="ifValid('distributors.turn_around_days')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="distributor.has_nda"
                                    :label="`${$t('lang.has_nda')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('distributors.has_nda')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="distributor.has_contract"
                                    :label="`${$t('lang.has_contract')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('distributors.has_contract')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.ship_label_type"
                                    :label="`${$t('lang.ship_label_type')} *`"
                                    :counter="showCounter(distributor.ship_label_type, 'distributors.ship_label_type')"
                                    :rules="ifValid('distributors.ship_label_type')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    v-model="distributor.notes"
                                    :label="$t('lang.notes')"
                                    auto-grow
                                    rows="1"
                                    :rules="ifValid('distributors.notes')"
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.logo_id"
                                    :label="$t('lang.logo_id')"
                                    :counter="showCounter(distributor.logo_id, 'distributors.logo_id')"
                                    :rules="ifValid('distributors.logo_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.packing_list_fields"
                                    :label="$t('lang.packing_list_fields')"
                                    :counter="showCounter(distributor.packing_list_fields, 'distributors.packing_list_fields')"
                                    :rules="ifValid('distributors.packing_list_fields')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="distributor.logo"
                                    :label="$t('lang.logo')"
                                    :counter="showCounter(distributor.logo, 'distributors.logo')"
                                    :rules="ifValid('distributors.logo')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="distributor.status"
                                    :label="`${$t('lang.status')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('distributors.status')"
                                ></bc-select>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'distributors' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveDistributors">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_distributor"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_distributor')"
                :message="$t('lang.delete_distributor_confirm')"
                @onConfirm="deleteDistributors()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_distributor_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteDistributorDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            distributor: {},
            file_name: "",
            dbGetDistributor: _.debounce(this.getDistributor, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchDistributor", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.distributor) {
                        this.distributor = this.assignObj2(data.distributor, this.rules_distributors);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=distributor_status&sort_by=2",
                            method: "get",
                            stateProperty: "distributor_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "distributors", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchDistributor", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.distributor) {
                        next((vm) => {
                            vm.distributor = vm.assignObj2(data.distributor, vm.rules_distributors);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=distributor_status&sort_by=2",
                                method: "get",
                                stateProperty: "distributor_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "distributors", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=distributor_status&sort_by=2",
            method: "get",
            stateProperty: "distributor_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_distributors: (state) => state.distributors.rules_distributors,
            distributor_status_options: (state) => state.settings.distributor_status_options,
            distributors: (state) => state.distributors.distributors,
            selectedDistributor: (state) => state.distributors.selectedDistributor,
            payment_terms: (state) => state.payment_terms.payment_term_options,
        }),
    },
    methods: {
        ...mapActions(["fetchDistributor", "saveDistributor", "deleteDistributor", "printDistributor", "fetchPaymentTerms"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getDistributor(pg_refresh = false) {
            this.startLoader();

            this.fetchDistributor({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.distributor) {
                    this.distributor = this.assignObj2(data.distributor, this.rules_distributors);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printDistributor({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.distributor) {
                    if (this.dev_mode) {
                        this.file_name = data.distributor.file_name;
                    } else {
                        this.$refs.print.printReport(data.distributor.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveDistributors() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formDistributor")) {
                    let body = this.prepForm(this.distributor, this.rules_distributors);

                    this.saveDistributor({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.distributor) {
                            this.$router.push({ name: "distributor", params: { id: data.distributor.company_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { company_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveDistributors({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.distributor) {
                    this.distributor = this.assignObj2(data.distributor, this.rules_distributors);
                }
            });
        },
        deleteDistributors() {
            this.deleteDistributor({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "distributors" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchDistributor({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.distributor) {
                        this.distributor = this.assignObj2(data.distributor, this.rules_distributors);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.payment_terms.length == 0 || force == true) await this.fetchPaymentTerms({ body: { options: 1 } });
        },
    },
    mounted() {
        this.refresh();
    },
    created() {},
};
</script>
